import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 1.333,
		y: 1.333,
		width: 21.333,
		height: 21.333,
		rx: 10.667,
		fill: "#2D343B"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.813 15.495a5.195 5.195 0 0 0-1.12-1.66 5.217 5.217 0 0 0-1.66-1.12l-.016-.006a3.444 3.444 0 1 0-4.033.001l-.017.007a5.173 5.173 0 0 0-1.66 1.12 5.217 5.217 0 0 0-1.529 3.577.111.111 0 0 0 .111.114h.834a.11.11 0 0 0 .11-.108 4.14 4.14 0 0 1 1.22-2.838A4.14 4.14 0 0 1 12 13.362a4.14 4.14 0 0 1 2.948 1.22 4.14 4.14 0 0 1 1.219 2.838.11.11 0 0 0 .111.108h.833a.11.11 0 0 0 .104-.07.113.113 0 0 0 .008-.044 5.174 5.174 0 0 0-.41-1.92ZM12 12.306a2.373 2.373 0 0 1-1.689-.7 2.374 2.374 0 0 1-.7-1.689c0-.637.25-1.237.7-1.689a2.373 2.373 0 0 1 1.69-.7c.637 0 1.237.249 1.688.7.452.452.7 1.052.7 1.69 0 .637-.248 1.237-.7 1.688-.451.451-1.051.7-1.689.7Z",
		fill: "#fff"
	})]
});
const ForwardRef = forwardRef(SvgPersonmin);
export { ForwardRef as ReactComponent };
